    import React, { useState, useEffect } from 'react';
    import { Form, Button, Modal, Row, Col, Alert, Spinner } from 'react-bootstrap';
    import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
    import { 
      faSave, 
      faTimes, 
      faBox, 
      faExclamationTriangle, 
      faCheck, 
      faInfoCircle 
    } from '@fortawesome/free-solid-svg-icons';
    import { Consumable } from '../interfaces'; // ייבוא Consumable
    import axios from 'axios';

    import { API_BASE_URL, buildApiUrl } from '../config/api';

    interface ConsumableFormProps {
      consumableToEdit?: Consumable | null;
      onSuccess: () => void;
      onCancel: () => void;
    }

    const ConsumableForm: React.FC<ConsumableFormProps> = ({ consumableToEdit, onSuccess, onCancel }) => {
      const [formData, setFormData] = useState<Consumable>({
        name: '',
        current_stock: 0,
        default_quantity: 0,
        min_stock_level: 0,
        unit: null,
        last_ordered_date: null,
        notes: null,
      });
      const [error, setError] = useState<string | null>(null);
      const [loading, setLoading] = useState<boolean>(false);

      useEffect(() => {
        if (consumableToEdit) {
          setFormData({
            ...consumableToEdit,
            unit: consumableToEdit.unit || null,
            notes: consumableToEdit.notes || null,
            last_ordered_date: consumableToEdit.last_ordered_date || null,
          });
        }
      }, [consumableToEdit]);

      const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
        if (type === 'number') {
          setFormData({ ...formData, [name]: parseInt(value) || 0 });
        } else {
          setFormData({ ...formData, [name]: value === '' ? null : value });
        }
      };

      const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        if (!formData.name) {
          setError("שם הפריט המתכלה הוא שדה חובה.");
          setLoading(false);
          return;
        }

        try {
          if (consumableToEdit && consumableToEdit.id) {
            await axios.put(buildApiUrl(`settings/consumables/${consumableToEdit.id}/`), formData);
          } else {
            await axios.post(buildApiUrl('settings/consumables/'), formData);
          }
          onSuccess();
        } catch (err) {
          console.error("שגיאה בשליחת טופס מתכלה:", err);
          if (axios.isAxiosError(err) && err.response && err.response.data) {
            let errorMessages = '';
            for (const key in err.response.data) {
              if (Object.prototype.hasOwnProperty.call(err.response.data, key)) {
                errorMessages += `${key}: ${err.response.data[key].join(', ')}\n`;
              }
            }
            setError(`שגיאה בשמירת הפריט המתכלה: \n${errorMessages || 'שגיאה לא ידועה.'}`);
          } else {
            setError("שגיאה בשמירת הפריט המתכלה. אנא נסה שוב.");
          }
        } finally {
          setLoading(false);
        }
      };

      return (
        <Form onSubmit={handleSubmit} className="p-4 border rounded shadow-sm bg-light">
          <h3 className="mb-4">{consumableToEdit ? 'עריכת פריט מתכלה' : 'הוספת פריט מתכלה חדש'}</h3>
          {error && <Alert variant="danger">{error}</Alert>}

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formConsumableName">
              <Form.Label>שם הפריט</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formCurrentStock">
              <Form.Label>מלאי נוכחי</Form.Label>
              <Form.Control
                type="number"
                name="current_stock"
                value={formData.current_stock}
                onChange={handleChange}
                min="0"
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formMinStockLevel">
              <Form.Label>סף מלאי מינימלי</Form.Label>
              <Form.Control
                type="number"
                name="min_stock_level"
                value={formData.min_stock_level}
                onChange={handleChange}
                min="0"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formDefaultQuantity">
              <Form.Label>כמות ברירת מחדל</Form.Label>
              <Form.Control
                type="number"
                name="default_quantity"
                value={formData.default_quantity}
                onChange={handleChange}
                min="0"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formUnit">
              <Form.Label>יחידת מדידה</Form.Label>
              <Form.Control
                type="text"
                name="unit"
                value={formData.unit || ''}
                onChange={handleChange}
                placeholder="לדוגמה: יחידות, מטר, קג"
              />
            </Form.Group>
          </Row>
          <Form.Group className="mb-3" controlId="formLastOrderedDate">
            <Form.Label>תאריך הזמנה אחרונה</Form.Label>
            <Form.Control
              type="date"
              name="last_ordered_date"
              value={formData.last_ordered_date || ''}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formConsumableNotes">
            <Form.Label>הערות</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="notes"
              value={formData.notes || ''}
              onChange={handleChange}
            />
          </Form.Group>

                      <div className="d-flex justify-content-end">
              <Button variant="secondary" onClick={onCancel} className="me-2" disabled={loading}>
                <FontAwesomeIcon icon={faTimes} className="me-1" />
                ביטול
              </Button>
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" /> : <><FontAwesomeIcon icon={faSave} className="me-1" /> {consumableToEdit ? 'עדכן פריט' : 'הוסף פריט'}</>}
              </Button>
            </div>
        </Form>
      );
    };

    export default ConsumableForm;